module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-189e6f07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Construction.vue
// module id = 71
// module chunks = 0